module.exports = __webpack_public_path__ + "static/img/search-icon.a6ef5219.svg";